import { Helper } from '../../Helper';
export class SetObjectPropertyHelperBase extends Helper {
    emit(sb, node, options) {
        sb.emitOp(node, 'ROT');
        sb.emitOp(node, 'ROT');
        sb.emitOp(node, 'TUCK');
        sb.emitOp(node, 'OVER');
        sb.emitOp(node, 'SWAP');
        sb.emitHelper(node, sb.pushValueOptions(options), sb.helpers.findObjectProperty({
            accessor: () => {
                sb.emitPushInt(node, 1);
                sb.emitOp(node, 'PICKITEM');
                sb.emitOp(node, 'ROT');
                sb.emitOp(node, 'DROP');
                sb.emitOp(node, 'ROT');
                sb.emitPushInt(node, 1);
                sb.emitOp(node, 'PACK');
                sb.emitOp(node, 'ROT');
                sb.emitOp(node, 'ROT');
                sb.emitHelper(node, sb.noPushValueOptions(options), sb.helpers.invokeCall({ bindThis: true, noArgs: false }));
            },
            dataExists: () => {
                sb.emitOp(node, 'NIP');
                sb.emitOp(node, 'NIP');
                sb.emitPushInt(node, 0);
                sb.emitOp(node, 'ROT');
                sb.emitOp(node, 'SETITEM');
            },
            data: () => {
                sb.emitOp(node, 'SWAP');
                sb.emitOp(node, 'ROT');
                sb.emitHelper(node, sb.noPushValueOptions(options), this.setDataProperty(sb));
            },
            getObject: this.getObject.bind(this),
        }));
    }
}

//# sourceMappingURL=SetObjectPropertyHelperBase.js.map
